import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonSharedModule } from '../../atoms/button/button.module';
import { IconSharedModule } from '../../atoms/icon/icon.module';
import { SocialBannerSharedComponent } from './social-banner.component';
import { InputSharedModule } from '../../molecules/input/input.module';

@NgModule({
    declarations: [
        SocialBannerSharedComponent
    ],
    imports: [
        CommonModule,
        ButtonSharedModule,
        IconSharedModule,
        InputSharedModule,
    ],
    exports: [
        SocialBannerSharedComponent
    ]
})
export class SocialBannerSharedModule {}
